(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27073],{

/***/ 33603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getTransitionName; }
/* harmony export */ });
// ================== Collapse Motion ==================
var getCollapsedHeight = function getCollapsedHeight() {
  return {
    height: 0,
    opacity: 0
  };
};

var getRealHeight = function getRealHeight(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};

var getCurrentHeight = function getCurrentHeight(node) {
  return {
    height: node.offsetHeight
  };
};

var skipOpacityTransition = function skipOpacityTransition(_, event) {
  return event.propertyName === 'height';
};

var collapseMotion = {
  motionName: 'ant-motion-collapse',
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
};

var getTransitionName = function getTransitionName(rootPrefixCls, motion, transitionName) {
  if (transitionName !== undefined) {
    return transitionName;
  }

  return "".concat(rootPrefixCls, "-").concat(motion);
};


/* harmony default export */ __webpack_exports__["Z"] = (collapseMotion);

/***/ }),

/***/ 31808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fk": function() { return /* binding */ detectFlexGapSupported; },
/* harmony export */   "jD": function() { return /* binding */ canUseDocElement; }
/* harmony export */ });
/* unused harmony export isStyleSupport */
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98924);

var canUseDocElement = function canUseDocElement() {
  return (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported() {
  if (!canUseDocElement()) {
    return false;
  }

  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  document.body.removeChild(flex);
  return flexGapSupported;
};

/***/ }),

/***/ 10808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ popover; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/getRenderPropValue.js
var getRenderPropValue = function getRenderPropValue(propValue) {
  if (!propValue) {
    return null;
  }

  var isRenderFunction = typeof propValue === 'function';

  if (isRenderFunction) {
    return propValue();
  }

  return propValue;
};
// EXTERNAL MODULE: ./node_modules/antd/es/_util/motion.js
var motion = __webpack_require__(33603);
;// CONCATENATED MODULE: ./node_modules/antd/es/popover/index.js


var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






var Popover = /*#__PURE__*/react.forwardRef(function (_a, ref) {
  var customizePrefixCls = _a.prefixCls,
      title = _a.title,
      content = _a.content,
      otherProps = __rest(_a, ["prefixCls", "title", "content"]);

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls;

  var getOverlay = function getOverlay(prefixCls) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, title && /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, getRenderPropValue(title)), /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-inner-content")
    }, getRenderPropValue(content)));
  };

  var prefixCls = getPrefixCls('popover', customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  return /*#__PURE__*/react.createElement(tooltip/* default */.Z, (0,esm_extends/* default */.Z)({}, otherProps, {
    prefixCls: prefixCls,
    ref: ref,
    overlay: getOverlay(prefixCls),
    transitionName: (0,motion/* getTransitionName */.m)(rootPrefixCls, 'zoom-big', otherProps.transitionName)
  }));
});
Popover.displayName = 'Popover';
Popover.defaultProps = {
  placement: 'top',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
};
/* harmony default export */ var popover = (Popover);

/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
function contains(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}

/***/ }),

/***/ 15105:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (KeyCode);

/***/ }),

/***/ 74204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollBarSize; }
/* harmony export */ });
/* unused harmony export getTargetScrollBarSize */
/* eslint-disable no-param-reassign */
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = '0';
    outerStyle.left = '0';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

function ensureSize(str) {
  var match = str.match(/^(.*)px$/);
  var value = Number(match === null || match === void 0 ? void 0 : match[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}

function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }

  var _getComputedStyle = getComputedStyle(target, '::-webkit-scrollbar'),
      width = _getComputedStyle.width,
      height = _getComputedStyle.height;

  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}

/***/ }),

/***/ 64217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pickAttrs; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */

var ariaPrefix = 'aria-';
var dataPrefix = 'data-';

function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */


function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;

  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }

  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if ( // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) || // Data
    mergedConfig.data && match(key, dataPrefix) || // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ }),

/***/ 93197:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ WebsocketRequest; },
  "XC": function() { return /* binding */ websocket_pb_WebsocketResponse; }
});

// UNUSED EXPORTS: WebsocketRequest_Request, WebsocketRequest_Request_Channel, WebsocketRequest_Request_Command

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/ping_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/ping.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.PingRequest
 */
const PingRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.PingRequest",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.PingResponse
 */
const PingResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.PingResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/auth_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/auth.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.AuthRequest
 */
const AuthRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.AuthResponse
 */
const AuthResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.AuthResponse",
  [],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm.proto (package securities.trm.core.smart_order.trailing_stop.order.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType
 */
const PriceAlgorithmType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType",
  [
    {no: 0, name: "PRICE_ALGORITHM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRICE_ALGORITHM_TYPE_TRAILING_STOP_PERCENTAGE", localName: "TRAILING_STOP_PERCENTAGE"},
  ],
);

/**
 * @generated from message securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm
 */
const PriceAlgorithm = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PriceAlgorithmType) },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/money_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/money.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents an amount of money with its currency type.
 *
 * @generated from message google.type.Money
 */
const Money = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Money",
  () => [
    { no: 1, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "units", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "nanos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/date_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/date.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message google.type.Date
 */
const date_pb_Date = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Date",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/entity/v2/portfolio_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/entity/v2/portfolio.proto (package securities.trm.core.portfolio.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * Side defines sides for an order
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.Side
 */
const Side = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIDE_BUY", localName: "BUY"},
    {no: 2, name: "SIDE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.PlatformOrderType
 */
const PlatformOrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.PlatformOrderType",
  [
    {no: 0, name: "PLATFORM_ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLATFORM_ORDER_TYPE_LIMIT_DAY", localName: "LIMIT_DAY"},
    {no: 2, name: "PLATFORM_ORDER_TYPE_MARKET_FAK", localName: "MARKET_FAK"},
    {no: 3, name: "PLATFORM_ORDER_TYPE_FAST_ORDER", localName: "FAST_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.LeverageType
 */
const LeverageType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.LeverageType",
  [
    {no: 0, name: "LEVERAGE_TYPE_TRADING_UNSPECIFIED", localName: "TRADING_UNSPECIFIED"},
    {no: 1, name: "LEVERAGE_TYPE_TRADING_BALANCE", localName: "TRADING_BALANCE"},
    {no: 2, name: "LEVERAGE_TYPE_TRADING_LIMIT", localName: "TRADING_LIMIT"},
    {no: 3, name: "LEVERAGE_TYPE_BASIC_LIMIT", localName: "BASIC_LIMIT"},
    {no: 4, name: "LEVERAGE_TYPE_TEMP_LIMIT", localName: "TEMP_LIMIT"},
    {no: 5, name: "LEVERAGE_TYPE_DAY_TRADE", localName: "DAY_TRADE"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.SecuritiesKind
 */
const SecuritiesKind = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SecuritiesKind",
  [
    {no: 0, name: "SECURITIES_KIND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SECURITIES_KIND_STOCK", localName: "STOCK"},
    {no: 2, name: "SECURITIES_KIND_BOND", localName: "BOND"},
  ],
);

/**
 * PortfolioListSummary contains summary of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary
 */
const PortfolioSummary = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary",
  () => [
    { no: 1, name: "trading", kind: "message", T: PortfolioSummary_Trading },
    { no: 2, name: "amount", kind: "message", T: PortfolioSummary_Amount },
    { no: 3, name: "profit_loss", kind: "message", T: PortfolioSummary_ProfitLoss },
    { no: 4, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "equity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "debt", kind: "message", T: PortfolioSummary_Debt },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading
 */
const PortfolioSummary_Trading = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading",
  () => [
    { no: 1, name: "balance", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Trading"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount
 */
const PortfolioSummary_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "allocated", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "credit_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss
 */
const PortfolioSummary_ProfitLoss = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss",
  () => [
    { no: 1, name: "net", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "unrealised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "realised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_ProfitLoss"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt
 */
const PortfolioSummary_Debt = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt",
  () => [
    { no: 1, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Debt"},
);

/**
 * PortfolioPrice contains price information in portfolio for one symbol
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice
 */
const PortfolioPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice",
  () => [
    { no: 1, name: "latest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: PortfolioPrice_Average },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average
 */
const PortfolioPrice_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioPrice_Average"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty
 */
const PortfolioQty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty",
  () => [
    { no: 1, name: "stock_on_hand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available", kind: "message", T: PortfolioQty_Qty },
    { no: 3, name: "balance", kind: "message", T: PortfolioQty_Qty },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty
 */
const PortfolioQty_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty",
  () => [
    { no: 1, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioQty_Qty"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset
 */
const PortfolioAsset = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset",
  () => [
    { no: 1, name: "unrealised", kind: "message", T: PortfolioAsset_Unrealised },
    { no: 2, name: "amount_invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised
 */
const PortfolioAsset_Unrealised = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised",
  () => [
    { no: 1, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "profit_loss", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioAsset_Unrealised"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioFlags
 */
const PortfolioFlags = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioFlags",
  () => [
    { no: 1, name: "allow_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "have_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_buy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_sell", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Order defines information on a single order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order
 */
const Order = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: Order_Time },
    { no: 8, name: "qty", kind: "message", T: Order_Qty },
    { no: 9, name: "price", kind: "message", T: Order_Price },
    { no: 10, name: "amount", kind: "message", T: Order_Amount },
    { no: 11, name: "action", kind: "message", T: Order_Action },
    { no: 12, name: "smart_order", kind: "message", T: Order_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: Order_GTC },
    { no: 14, name: "day_trade", kind: "message", T: Order_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "securities_kind", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SecuritiesKind) },
    { no: 18, name: "platform_order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlatformOrderType) },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell
 */
const Order_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount
 */
const Order_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: Order_Amount_Fee },
  ],
  {localName: "Order_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee
 */
const Order_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: Order_Amount_Fee_Matched },
  ],
  {localName: "Order_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched
 */
const Order_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price
 */
const Order_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: Order_Price_Average },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price.Average
 */
const Order_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Time
 */
const Order_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Time",
  () => [
    { no: 1, name: "order", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "open", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "match", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "Order_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Action
 */
const Order_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Order_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder
 */
const Order_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "trailing_stop", kind: "message", T: Order_SmartOrder_TrailingStop },
  ],
  {localName: "Order_SmartOrder"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop
 */
const Order_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "Order_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.GTC
 */
const Order_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_GTC_GTCStatus) },
  ],
  {localName: "Order_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus
 */
const Order_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Qty
 */
const Order_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.DayTrade
 */
const Order_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_DayTradeForceSell) },
  ],
  {localName: "Order_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail
 */
const OrderDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: OrderDetail_Time },
    { no: 8, name: "qty", kind: "message", T: OrderDetail_Qty },
    { no: 9, name: "price", kind: "message", T: OrderDetail_Price },
    { no: 10, name: "amount", kind: "message", T: OrderDetail_Amount },
    { no: 11, name: "action", kind: "message", T: OrderDetail_Action },
    { no: 12, name: "smart_order", kind: "message", T: OrderDetail_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: OrderDetail_GTC },
    { no: 14, name: "day_trade", kind: "message", T: OrderDetail_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
  ],
)));

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell
 */
const OrderDetail_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount
 */
const OrderDetail_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: OrderDetail_Amount_Fee },
  ],
  {localName: "OrderDetail_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee
 */
const OrderDetail_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: OrderDetail_Amount_Fee_Matched },
  ],
  {localName: "OrderDetail_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched
 */
const OrderDetail_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price
 */
const OrderDetail_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: OrderDetail_Price_Average },
  ],
  {localName: "OrderDetail_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average
 */
const OrderDetail_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "portfolio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Time
 */
const OrderDetail_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Time",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "opened_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "matched_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "OrderDetail_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Action
 */
const OrderDetail_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "OrderDetail_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder
 */
const OrderDetail_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_SmartOrder_ConfigPriceType) },
    { no: 5, name: "trailing_stop", kind: "message", T: OrderDetail_SmartOrder_TrailingStop },
  ],
  {localName: "OrderDetail_SmartOrder"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType
 */
const OrderDetail_SmartOrder_ConfigPriceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType",
  [
    {no: 0, name: "CONFIG_PRICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIG_PRICE_TYPE_ABOVE", localName: "ABOVE"},
    {no: 2, name: "CONFIG_PRICE_TYPE_BELOW", localName: "BELOW"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop
 */
const OrderDetail_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "OrderDetail_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.GTC
 */
const OrderDetail_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_GTC_GTCStatus) },
  ],
  {localName: "OrderDetail_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus
 */
const OrderDetail_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Qty
 */
const OrderDetail_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade
 */
const OrderDetail_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_DayTradeForceSell) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "OrderDetail_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Company
 */
const Company = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Company",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData
 */
const ExerciseData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "date", kind: "message", T: ExerciseData_Date },
    { no: 9, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData.Date
 */
const ExerciseData_Date = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData.Date",
  () => [
    { no: 1, name: "listing", kind: "message", T: date_pb_Date },
    { no: 2, name: "expired", kind: "message", T: date_pb_Date },
    { no: 3, name: "mature", kind: "message", T: date_pb_Date },
    { no: 4, name: "start", kind: "message", T: date_pb_Date },
    { no: 5, name: "end", kind: "message", T: date_pb_Date },
  ],
  {localName: "ExerciseData_Date"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioItem
 */
const PortfolioItem = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioItem",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail
 */
const PortfolioDetail = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "bond", kind: "message", T: PortfolioDetail_Bond },
    { no: 9, name: "can_create_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond
 */
const PortfolioDetail_Bond = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond",
  () => [
    { no: 1, name: "coupon", kind: "message", T: PortfolioDetail_Bond_Coupon },
    { no: 2, name: "maturity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon
 */
const PortfolioDetail_Bond_Coupon = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon",
  () => [
    { no: 1, name: "year_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond_Coupon"},
);

/**
 * PortfolioList defines data on response PortfolioListResponse
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList
 */
const PortfolioList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList",
  () => [
    { no: 1, name: "smart_order_info", kind: "message", T: PortfolioList_SmartOrderInfo },
    { no: 2, name: "summary", kind: "message", T: PortfolioSummary },
    { no: 3, name: "results", kind: "message", T: PortfolioItem, repeated: true },
    { no: 4, name: "day_trade", kind: "message", T: PortfolioItem, repeated: true },
  ],
);

/**
 * PortfolioListInfo contains info of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo
 */
const PortfolioList_SmartOrderInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo",
  () => [
    { no: 1, name: "can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "day_trade_can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "PortfolioList_SmartOrderInfo"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/wsevent/v1/securities_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/wsevent/v1/securities.proto (package securities.trm.core.portfolio.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * WebsocketResponse defines messages when sending response to websocket client
 *
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse
 */
const WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "action", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketResponse_Action) },
    { no: 2, name: "portfolio_summary", kind: "message", T: PortfolioSummary, oneof: "message" },
    { no: 3, name: "portfolio_detail", kind: "message", T: PortfolioDetail, oneof: "message" },
    { no: 4, name: "portfolio_list", kind: "message", T: PortfolioList, oneof: "message" },
    { no: 5, name: "order_detail", kind: "message", T: Order, oneof: "message" },
    { no: 6, name: "order_list", kind: "message", T: WebsocketResponse_OrderList, oneof: "message" },
    { no: 7, name: "portfolio_detail_day_trade", kind: "message", T: PortfolioDetail, oneof: "message" },
  ],
);

/**
 * Action provides various action can applied to websocket message
 *
 * @generated from enum securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action
 */
const WebsocketResponse_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_UPSERT", localName: "UPSERT"},
    {no: 2, name: "ACTION_DELETE", localName: "DELETE"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList
 */
const WebsocketResponse_OrderList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList",
  () => [
    { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
  ],
  {localName: "WebsocketResponse_OrderList"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/websocket.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * WebsocketRequest handles request for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest
 */
const WebsocketRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: WebsocketRequest_Request, repeated: true },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest.Request
 */
const WebsocketRequest_Request = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "command", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Command), oneof: "action" },
    { no: 3, name: "subscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
    { no: 4, name: "unsubscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
  ],
  {localName: "WebsocketRequest_Request"},
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Command
 */
const WebsocketRequest_Request_Command = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_PING", localName: "PING"},
    {no: 2, name: "COMMAND_AUTH", localName: "AUTH"},
  ],
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel
 */
const WebsocketRequest_Request_Channel = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel",
  [
    {no: 0, name: "CHANNEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHANNEL_SECURITIES_LIVE_PORTO", localName: "SECURITIES_LIVE_PORTO"},
  ],
);

/**
 * WebsocketResponse handles response for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketResponse
 */
const websocket_pb_WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "response" },
    { no: 3, name: "auth", kind: "message", T: AuthResponse, oneof: "response" },
    { no: 4, name: "securities", kind: "message", T: WebsocketResponse, oneof: "response" },
  ],
);



/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);